export const currentPairSelector = state => state.currentPair.pair;
